import { createApp, computed } from 'vue'
import { createPinia } from 'pinia'
import { useProductHistoryStore } from '@/src/stores/productHistory.store'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import ProductHistorySearch from '@/src/javascripts/product_histories/ProductHistorySearch.vue'

$(document).on('turbo:load turbo:render', () => {
  const productHistoryIndex = document.querySelector('#product-history-index')
  if (productHistoryIndex && !productHistoryIndex.__vue_app__) {
    const pinia = createPinia()
    const app = createApp({
      components: { BaseAlert, ProductHistorySearch },
      setup () {
        const productHistoryStore = useProductHistoryStore()
        const showtip = computed(() => productHistoryStore.showtip)
        return {
          showtip
        }
      }
    })

    app.use(pinia)
    app.mount(productHistoryIndex)
  }
})
